import { UserCollection } from "types";

export const GetUserName = (UserCollection: UserCollection[], id: string) => {
  const user = UserCollection.filter(f => f.id === id)[0];
  if (user) return user.name;
  return null;
};
